import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { css } from "@emotion/core"
import {
  weddingPartyMember,
  weddingPartyContent,
  contentLeft,
  weddingPartyMemberImage,
} from "../weddingPartyMember"

const imageWrapper = css`
  position: relative;
  top: -20px;

  @media screen and (min-width: 680px) {
    position: absolute;
    top: -20px;
    right: -60px;
  }

  @media screen and (min-width: 860px) {
    width: 420px;
  }
`

const Blair = props => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "blair.png" }) {
        childImageSharp {
          # Specify the image processing specifications right in the query.
          # Makes it trivial to update as your page's design changes.
          fluid(maxWidth: 420) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <div css={weddingPartyMember}>
      <div css={[weddingPartyMemberImage, imageWrapper]}>
        <Img
          fluid={data.file.childImageSharp.fluid}
          imgStyle={{ objectFit: "contain" }}
          {...props}
        />
      </div>
      <div css={[weddingPartyContent, contentLeft]}>
        <div>
          <h2>Blair Penner</h2>
          <p>
            Childhood friend, Brookside bad boy, and lawn game champion. The
            best of friends to break bread with, and a literal inferno on the
            grill. Can't eat a whole pound of pasta.
          </p>
        </div>
      </div>
    </div>
  )
}

export default Blair
